import styled from 'styled-components';

const LoadingImage = styled.img`
    padding: 50px;
    display: block;
    overflow: visible;
`;

export default LoadingImage;



// WEBPACK FOOTER //
// ./src/components/atoms/LoadingImage.js